// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2TDja","icon":"index_icon_EcMDP","title":"index_title_2aLDg","line":"index_line_K1Hk8"};